import { Component, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderService } from 'src/app/core/services/loader';
import { SharedService } from 'src/app/core/services/shared';
import { ModalNovaImportacaoComponent } from 'src/app/features/movimentacao-cadastral/components/modal-nova-importacao';

@Component({
  selector: 'app-super-smart',
  templateUrl: './super-smart.component.html',
  styleUrls: ['./super-smart.component.scss'],
})
export class SuperSmartComponent {
  matDialog = inject(MatDialog);
  loader = inject(LoaderService);
  sharedService = inject(SharedService);
  appName = this.sharedService.GetAppName();
  showCorrect1 = false;

  showCorrect2 = false;

  temArquivo = false;

  cnpjCtrl = new FormControl('', Validators.required);

  apoliceCtrl = new FormControl('', Validators.required);

  displayedColumns = [
    'statusProdutoBeneficiario',
    'nomeBeneficiario',
    'tipoBeneficiario',
    'apelidoProvedorGeral',
    'descricaoProduto',
    'tipoMovimentacao',
  ];

  dataSource = new MatTableDataSource([
    {
      nomeBeneficiario: 'Pietro Batista',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Emanuel Moraes',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Igor Xavier',
      tipoBeneficiario: 1,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Washington Costa',
      tipoBeneficiario: 1,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Elisa Moraes',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Breno Batista',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Julia Souza',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Noah Saraiva',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Margarida Silva',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
    {
      nomeBeneficiario: 'Nataniel Melo',
      tipoBeneficiario: 0,
      nomeFantasiaProvedorGeral: '',
      descricaoProduto: 'Plano A',
      statusProdutoBeneficiario: 0,
      tipoMovimentacao: 0,
    },
  ]);

  loadCnpj(): void {
    if (this.cnpjCtrl.invalid) {
      return;
    }

    const loaderRef = this.loader.open('Carregando dados do CNPJ...');

    setTimeout(() => {
      loaderRef.close();
      this.showCorrect1 = true;
    }, 2000);
  }

  onUploadClick(): void {
    this.matDialog
      .open(ModalNovaImportacaoComponent, {
        maxWidth: '700px',
        autoFocus: false,
        data: {
          mock: true,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        this.temArquivo = true;
      });
  }
}
